module.exports = __webpack_public_path__ + "static/img/footer-Supplier.c6c661f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer-Supplier.png
// module id = ExWp
// module chunks = 0